import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { Icon } from '@vfgroup-oneplatform/foundation/Components';
import {
  getThemeImages,
  useTheme,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './Header.Styles';

const Header = ({ withBackButton, onBackPress, onClosePress }) => {
  const theme = useTheme() || LightThemeColors;
  const images = getThemeImages(theme.name);

  return (
    <View style={styles.headerContainerStyle} testID={FrameworkTestKeys.BLOHeaderView}>
      {withBackButton && (
        <TouchableWithoutFeedback onPress={onBackPress} testID={FrameworkTestKeys.BLOHeaderTWF}>
          <View
            style={styles.backButtonContainerStyle}
            testID={FrameworkTestKeys.BLOHeaderContainerView}
          >
            <Icon
              name={images.ic_arrow_left}
              type="image"
              size={25.2}
              testID={FrameworkTestKeys.BackgroundLocationOverlay}
            />
          </View>
        </TouchableWithoutFeedback>
      )}

      <TouchableWithoutFeedback onPress={onClosePress} testID={FrameworkTestKeys.BLOHeaderCloseTWF}>
        <View
          style={styles.closeButtonContainer}
          testID={FrameworkTestKeys.BLOHeaderCloseContainer}
        >
          <Icon
            name={images.ic_close}
            type="image"
            size={25.2}
            testID={FrameworkTestKeys.BLOHeaderCloseIcon}
          />
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

Header.defaultProps = {
  theme: LightThemeColors,
};

Header.propTypes = {
  withBackButton: PropTypes.bool,
  onBackPress: PropTypes.func,
  onClosePress: PropTypes.func,
};

export default Header;
